import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useUser } from "@/context/user-context";
import { DialogOverlay } from "@radix-ui/react-dialog";
import { FC } from "react";
import CreateInviteForm from "./Settings/components/CreateInviteForm";

type AddWorkspaceMemberProps = {
  setOpen: (isOpen: boolean) => void;
  isOpen: boolean;
};

const AddWorkspaceMemberModal: FC<AddWorkspaceMemberProps> = ({
  setOpen,
  isOpen,
}) => {
  const userContext = useUser();

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogOverlay className="fixed inset-0 bg-gray-800/30 backdrop-blur-sm" />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite to Workspace</DialogTitle>
        </DialogHeader>
        <CreateInviteForm
          onSuccess={() => {
            setOpen(false);
          }}
          workspace={userContext.activeWorkspace}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddWorkspaceMemberModal;
